// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"_2Nx2teZknvMt_cqQLm934G","closeIcon":"_12Dk_Rc3QPFLuboIbiU8bK","item":"_1Dri4IDeoweylSkWPoWbIu"};